import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Tournament } from "../../../../../shared/models";
import { User } from "../../../../../shared/models/user";
import { TournamentRegistrationType } from "../../button-tournament-registration/button-tournament-registration.component";
import { ManagerService } from "../../../../../core/services/manager.service";
import { TournamentStatus2 } from "../../../../../shared/enums/poker-types";

enum NavItems {
  TourneyInfo,
  Players,
  Payouts,
  ActiveTables,
  Structure,
}

@Component({
  selector: "app-view-tournament-container",
  templateUrl: "./view-tournament-container.component.html",
  styleUrls: ["./view-tournament-container.component.scss"],
})
export class ViewTournamentContainerComponent implements OnChanges {
  @Input() user: User;
  @Input() tournament: Tournament;

  currentTab: NavItems = NavItems.TourneyInfo;
  TabItems = NavItems;
  type: TournamentRegistrationType;
  text: string;
  enumTournamentRegistrationType = TournamentRegistrationType;
  enabled: boolean;
  imageUrl: string;

  myActiveTable: number;

  constructor(private managerService: ManagerService) {}

  ngOnChanges(): void {
    this.getButtonsText();
  }

  setNav(nav: NavItems) {
    this.currentTab = nav;
  }

  getButtonsText() {
    if (!this.tournament || !this.tournament.tourSum) {
      return;
    }

    const { Status2 } = this.tournament.tourSum;
    for (const item of Object.keys(this.managerService.activeGames)) {
      if (
        this.managerService.activeGames[item]?.table?.IdTournament ===
        this.tournament.tourSum.Id
      ) {
        this.myActiveTable = +item;
        break;
      }
    }

    // Handle different tournament statuses
    switch (Status2) {
      case TournamentStatus2.Announced:
        this.setButton(
          "tournamentRegister.announced",
          this.enumTournamentRegistrationType.ANNOUNCED,
          false,
        );
        break;

      case TournamentStatus2.RegistrationOpen:
        if (this.tournament.isRegistered) {
          this.setButton(
            "tournamentRegister.registering",
            this.enumTournamentRegistrationType.UNREGISTER,
            true,
          );
        } else {
          this.setButton(
            "tournamentRegister.registering",
            this.enumTournamentRegistrationType.REGISTER,
            true,
          );
        }
        break;

      case TournamentStatus2.RunningWithLateRegistration:
        this.handleRunningWithLateRegistration();
        break;

      case TournamentStatus2.RunningRegistrationClosed:
        this.setButton(
          "LABEL.RUNNING",
          this.enumTournamentRegistrationType.REGISTRATION_CLOSED,
          false,
        );
        break;

      case TournamentStatus2.Completed:
        this.setButton(
          "tournamentRegister.completed",
          this.enumTournamentRegistrationType.COMPLETED,
          false,
        );
        break;

      case TournamentStatus2.Canceled:
        this.setButton(
          "tournamentRegister.cancelled",
          this.enumTournamentRegistrationType.CANCELED,
          false,
        );
        break;

      default:
        this.enabled = false;
    }
  }

  private setButton(text: string, type: number, enabled: boolean) {
    this.text = text;
    this.type = type;
    this.imageUrl = `assets/images/tournament/status_${type}.png`;
    this.enabled = enabled;
  }

  private handleRunningWithLateRegistration() {
    if (this.tournament.isRegistered) {
      const { ImRegistered, ImEliminated, OptionReEntry } =
        this.tournament.tourSum;
      this.enabled = ImRegistered && ImEliminated && OptionReEntry;
    } else {
      this.enabled = true;
    }

    this.text = "page.lobby.table.data.status.lateRegistration";
    this.type = this.enumTournamentRegistrationType.JUMP_IN;
  }
}
